import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/front_end/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/app/(embed)/questions/embed/[id]/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/forecast_card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/post_card/community_disclaimer.tsx");
